import Vue from 'vue'
import AgGridMethodsMixins from '@/Mixins/SigmaClientNew/GeneralLedgerWorksheet/Methods'
import AgGridColumnMethodMixins from '@/Mixins/SigmaClientNew/GeneralLedgerWorksheet/ColumnMethods'

/*
 * AG Grid Column Defs here
 */
export default Vue.extend({
  mixins: [AgGridMethodsMixins, AgGridColumnMethodMixins],
  data () {
    return {
      accountIdColumn: {
        headerName: 'ID',
        field: 'account_id',
        colId: 'account_id',
        width: 1,
        editable: false,
        valueGetter: (params) => (params.data ? params.data.account_id : ''),
        valueSetter: () => null
      },
      accountCodeColumn: {
        headerName: 'Account',
        field: 'account',
        colId: 'account',
        maxWidth: 300,
        minWidth: 100,
        editable: (params) => params.data ? this.isEditable(params) : false,
        valueGetter: (params) => (params.data ? params.data.account : ''),
        valueSetter: (params) => {
          if (params.newValue && params.newValue !== '') {
            params.data.edited = true
            params.data.account = params.newValue
          }
        }
      },
      accountNameColumn: {
        headerName: 'Account Name',
        field: 'account_name',
        colId: 'account_name',
        maxWidth: 400,
        minWidth: 100,
        editable: false,
        valueGetter: (params) => (params.data ? params.data.account_name : ''),
        valueSetter: () => null
      },
      accountTypeColumn: {
        headerName: 'Type',
        field: 'type',
        colId: 'type',
        maxWidth: 150,
        editable: false,
        hide: true,
        aggFunc: 'first',
        valueGetter: (params) => {
          if (!params.data) {
            return ''
          } else {
            switch (params.data.type.toLowerCase()) {
              case 'grand_total':
                return 'GRAND TOTAL'
              default:
                return 'UNKNOWN EXPENSES'
            }
          }
        },
        valueSetter: () => null
      },
      TransactionNumberColumn: {
        headerName: 'Trans #',
        field: 'trans_number',
        colId: 'trans_number',
        maxWidth: 200,
        minWidth: 75,
        editable: false,
        valueGetter: (params) => (params.data ? params.data.trans_number : ''),
        valueSetter: () => null
      },
      descriptionColumn: {
        headerName: 'GL Description',
        field: 'line_desc',
        colId: 'line_desc',
        maxWidth: 300,
        minWidth: 100,
        editable: (params) => params.data ? this.isEditable(params) : false,
        valueGetter: (params) => (params.data ? params.data.line_desc : ''),
        valueSetter: (params) => {
          if (params.newValue && params.newValue !== '') {
            params.data.edited = true
            params.data.line_desc = params.newValue
          }
        }
      },
      vendorColumn: {
        headerName: 'Vendor',
        field: 'vendor_name',
        colId: 'vendor_name',
        maxWidth: 300,
        minWidth: 100,
        editable: false,
        valueGetter: (params) => (params.data ? params.data.vendor_name : ''),
        valueSetter: () => null
      },
      seriesColumn: {
        headerName: 'Ser',
        field: 'series',
        colId: 'series',
        maxWidth: 100,
        minWidth: 75,
        editable: (params) => params.data ? this.isEditable(params) : false,
        valueGetter: (params) => (params.data ? params.data.series : ''),
        valueSetter: (params) => {
          if (params.newValue && params.newValue !== '') {
            params.data.edited = true
            params.data.series = params.newValue
          }
        }
      },
      locationColumn: {
        headerName: 'Loc',
        field: 'location',
        colId: 'location',
        maxWidth: 100,
        minWidth: 75,
        editable: (params) => params.data ? this.isEditable(params) : false,
        valueGetter: (params) => (params.data ? params.data.location : null),
        valueSetter: (params) => {
          if (params.newValue && params.newValue !== '') {
            params.data.edited = true
            params.data.location = params.newValue
          }
        }
      },
      setColumn: {
        headerName: 'Set',
        field: 'set',
        colId: 'set',
        maxWidth: 100,
        minWidth: 75,
        editable: (params) => params.data ? this.isEditable(params) : false,
        valueGetter: (params) => (params.data ? params.data.set : null),
        valueSetter: (params) => {
          if (params.newValue && params.newValue !== '') {
            params.data.edited = true
            params.data.set = params.newValue
          }
        }
      },
      freeField1Column: {
        headerName: 'FF1',
        field: 'free_field_1',
        colId: 'free_field_1',
        maxWidth: 100,
        minWidth: 75,
        editable: (params) => params.data ? this.isEditable(params) : false,
        valueGetter: (params) => (params.data ? params.data.free_field_1 : null),
        valueSetter: (params) => {
          params.data.edited = true
          params.data.free_field_1 = params.newValue
        }
      },
      freeField2Column: {
        headerName: 'FF2',
        field: 'free_field_2',
        colId: 'free_field_2',
        maxWidth: 100,
        minWidth: 75,
        editable: (params) => params.data ? this.isEditable(params) : false,
        valueGetter: (params) => (params.data ? params.data.free_field_2 : null),
        valueSetter: (params) => {
          params.data.edited = true
          params.data.free_field_2 = params.newValue
        }
      },
      freeField3Column: {
        headerName: 'FF3',
        field: 'free_field_3',
        colId: 'free_field_3',
        maxWidth: 100,
        minWidth: 75,
        editable: (params) => params.data ? this.isEditable(params) : false,
        valueGetter: (params) => (params.data ? params.data.free_field_3 : null),
        valueSetter: (params) => {
          params.data.edited = true
          params.data.free_field_3 = params.newValue
        }
      },
      freeField4Column: {
        headerName: 'FF4',
        field: 'free_field_4',
        colId: 'free_field_4',
        maxWidth: 100,
        minWidth: 75,
        editable: (params) => params.data ? this.isEditable(params) : false,
        valueGetter: (params) => (params.data ? params.data.free_field_4 : null),
        valueSetter: (params) => {
          params.data.edited = true
          params.data.free_field_4 = params.newValue
        }
      },
      insuranceColumn: {
        headerName: 'Ins',
        field: 'ins',
        colId: 'ins',
        maxWidth: 100,
        minWidth: 75,
        editable: false,
        valueGetter: (params) => (params.data ? params.data.ins : null),
        valueSetter: (params) => {
          params.data.edited = true
          params.data.ins = params.newValue
        }
      },
      taxCodeColumn: {
        headerName: '9',
        field: 'tax_code',
        colId: 'tax_code',
        maxWidth: 100,
        minWidth: 75,
        editable: (params) => params.data ? this.isEditable(params) : false,
        valueGetter: (params) => (params.data ? params.data.tax_code : null),
        valueSetter: (params) => {
          params.data.edited = true
          params.data.tax_code = params.newValue
        }
      },
      assetColumn: {
        headerName: 'A',
        field: 'asset',
        colId: 'asset',
        maxWidth: 100,
        minWidth: 75,
        editable: (params) => params.data ? this.isEditable(params) : false,
        valueGetter: (params) => (params.data ? params.data.asset : null),
        valueFormatter: (params) => {
          if (params.value === true || params.value === 'true') {
            return 'X'
          } else {
            return ''
          }
        },
        valueSetter: (params) => {
          params.data.edited = true
          params.data.asset = params.newValue
        }
      },
      documentNumberColumn: {
        headerName: 'Doc #',
        field: 'doc_number',
        colId: 'doc_number',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        valueGetter: (params) => (params.data ? params.data.doc_number : null),
        valueSetter: (params) => {
          params.data.edited = true
          params.data.doc_number = params.newValue
        }
      },
      dateColumn: {
        headerName: 'Date',
        field: 'transaction_effective_date',
        colId: 'transaction_effective_date',
        maxWidth: 100,
        minWidth: 75,
        editable: false,
        valueGetter: (params) => (params.data && params.data.transaction_effective_date ? new Intl.DateTimeFormat('en-US').format(new Date(params.data.transaction_effective_date)) : null),
        valueSetter: () => null
      },
      poNumberColumn: {
        headerName: 'PO #',
        field: 'po_number',
        colId: 'po_number',
        editable: false,
        maxWidth: 200,
        minWidth: 100,
        valueGetter: (params) => (params.data ? params.data.po_number : null),
        valueSetter: () => null
      },
      paymentNumberColumn: {
        headerName: 'Check',
        field: 'payment_number',
        colId: 'payment_number',
        editable: false,
        maxWidth: 100,
        minWidth: 75,
        valueGetter: (params) => (params.data ? params.data.payment_number : null),
        valueSetter: () => null
      },
      currencyColumn: {
        headerName: 'Cur',
        field: 'transaction_currency',
        colId: 'transaction_currency',
        maxWidth: 100,
        minWidth: 75,
        editable: false,
        valueGetter: (params) => (params.data ? params.data.transaction_currency : null),
        valueSetter: () => null
      },
      amountColumn: {
        headerName: 'Amount',
        field: 'amount',
        colId: 'amount',
        cellClass: 'amount',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.$data.scope.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => (params.data ? params.data.amount : 0),
        valueSetter: () => null
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/Mixins/SigmaClientNew/GeneralLedgerWorksheet/Columns.js